import { FunctionalComponent } from 'preact'
import { ToggleRow } from '@/components/common/ToggleRow'

interface TrackingToggleProps {
  enabled: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  label?: string
}

export const TrackingToggle: FunctionalComponent<TrackingToggleProps> = ({
  enabled,
  onChange,
  disabled = false,
  label = 'Enable tracking',
}) => {
  return (
    <label
      className={`flex items-center gap-3 py-2 ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      }`}
    >
      <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
        {label}
      </span>
      <ToggleRow
        ariaLabel={label}
        checked={enabled}
        onChange={onChange}
        disabled={disabled}
        size="default"
      />
    </label>
  )
}
